import { useTheme } from "../../context/ThemeContext";

export default function SearchInput({
  value,
  onChange,
  placeholder = "Search...",
}) {
  const { isDark } = useTheme();

  return (
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={`
        w-full
        px-4
        py-3
        rounded-xl
        border
        outline-none
        transition
        ${
          isDark
            ? "bg-white/5 border-white/10 text-white"
            : "bg-white border-gray-300"
        }
      `}
    />
  );
}